import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    isLoading:false,
    isLoadingSocial:false,
    dashboard_analytics:"",
    socialShare:{}
}

const dashboardAnalytics = createSlice({
    name:"dashboard-analytics",
    initialState,

    reducers:{
        IsLoading:(state) => {
            state.isLoading = true
            state.isLoadingSocial = true
        },
        DashboardAnalyticsAll:(state, {payload}) => {
            state.dashboard_analytics = payload
            state.isLoading = false
        },
        SocialShare:(state, {payload}) => {
            state.socialShare = payload
            state.isLoadingSocial = false
        }
    }
})

export const {
    DashboardAnalyticsAll,
    SocialShare,
    IsLoading
} = dashboardAnalytics.actions
export default dashboardAnalytics.reducer

